export interface StandardizedSport {
  uuid: string;
  external_key: string;
  label: string;
  sort_order: number;
}

export interface ApiTeam {
  name: string;
  twrn: string;
  sport_type: StandardizedSport | null;
}

export class Team {
  name: string;
  twrn: string;
  sportType: StandardizedSport | null;
  constructor(data: ApiTeam) {
    this.name = data.name;
    this.twrn = data.twrn;
    this.sportType = data.sport_type;
  }
}

const FOOTBALL_EXTERNAL_KEY = 'american_football';

export function isFootballTeam(sportType: StandardizedSport | null | undefined): boolean {
  if (!sportType) return false;
  return sportType.external_key === FOOTBALL_EXTERNAL_KEY;
}

export function getSportTypeKey(sportType: StandardizedSport | null | undefined): string | null {
  if (!sportType) return null;
  return sportType.external_key;
}

export interface ApiTeamListing {
  name: string;
  twrn: string;
}

export class TeamListing {
  name: string;
  twrn: string;
  private _teamMap: Map<string, string>;

  constructor(data: ApiTeamListing) {
    this.name = data.name;
    this.twrn = data.twrn;
    this._teamMap = new Map<string, string>();
    this._teamMap.set(data.twrn, data.name);
  }

  getTeamName(twrn: string) {
    return this._teamMap.get(twrn);
  }
}

export interface ApiTeamsListingResponse {
  data: ApiTeamListing[];
}

export class TeamsListingResponse {
  teams: TeamListing[];
  private _teamMap: Map<string, string>;

  constructor(data: ApiTeamsListingResponse) {
    this.teams = data.data.map((team) => new TeamListing(team));
    this._teamMap = new Map<string, string>();

    this.teams.forEach((team) => {
      this._teamMap.set(team.twrn, team.name);
    });
  }

  getTeamName(twrn: string) {
    return this._teamMap.get(twrn);
  }
}
